'use strict';

export function init() {
    const navButtons = document.querySelectorAll('.orchestra-roster__switch');
    const instrumentSection = document.querySelector('.orchestra-roster__section--instrument');
    const namesSection = document.querySelector('.orchestra-roster__section--names');

    navButtons.forEach(button => {
    button.addEventListener('click', () => {
        const target = button.dataset.target;
        console.log('Clicked target:', target);  // Debug


        // Toggle active class on buttons
        navButtons.forEach(btn => btn.classList.remove('orchestra-roster__switch--active'));
        button.classList.add('orchestra-roster__switch--active');

        // Toggle sections
        const isInstrument = target === 'instrument';

        instrumentSection.classList.toggle('active', isInstrument);
        namesSection.classList.toggle('active', !isInstrument);
    });
    });

    // Initialize instrument toggle functionality
    initInstrumentToggle();
}

function initInstrumentToggle() {
    const instrumentHeaders = document.querySelectorAll('[data-toggle="instrument"]');

    instrumentHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const instrumentContainer = header.closest('.orchestra-roster__instrument');
            instrumentContainer.classList.toggle('orchestra-roster__instrument--open');
        });
    });
}
